import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Facebook, MapPin, Phone, Mail, ArrowRight } from 'lucide-react';
import { NAV, SITE } from '@/lib/site';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#144726] text-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center">
              <img src="/brand/cespedis-logo-md.png" alt="Cespedis" className="h-12 w-auto brightness-0 invert opacity-95" />
            </Link>
            <p className="mt-5 max-w-md font-display text-2xl text-[#C6A35B]">{SITE.tagline}</p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/70">
              {SITE.longTagline}
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
              Cespedis Property Management & Commercial Leasing helps property owners, developers, and corporate occupiers across Hyderabad unlock value through disciplined leasing and professional asset management.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href={SITE.socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="flex h-9 w-9 items-center justify-center rounded-md border border-white/15 text-white/80 hover:border-[#C6A35B] hover:text-[#C6A35B] transition-colors" data-testid="footer-social-linkedin"><Linkedin className="h-4 w-4" /></a>
              <a href={SITE.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-md border border-white/15 text-white/80 hover:border-[#C6A35B] hover:text-[#C6A35B] transition-colors" data-testid="footer-social-instagram"><Instagram className="h-4 w-4" /></a>
              <a href={SITE.socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-md border border-white/15 text-white/80 hover:border-[#C6A35B] hover:text-[#C6A35B] transition-colors" data-testid="footer-social-facebook"><Facebook className="h-4 w-4" /></a>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C6A35B]">Navigate</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/80">
              {NAV.map((n) => (
                <li key={n.href}>
                  <Link to={n.href} className="hover:text-[#C6A35B] transition-colors" data-testid={`footer-nav-${n.label.toLowerCase()}`}>{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C6A35B]">Get in Touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-white/80">
              <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#C6A35B]" /><span>{SITE.address}</span></li>
              <li className="flex gap-3"><Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#C6A35B]" /><a href={`tel:${SITE.phoneTel}`} className="hover:text-white">{SITE.phone}</a></li>
              <li className="flex gap-3"><Mail className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#C6A35B]" /><a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
            </ul>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-2 rounded-lg bg-[#C6A35B] px-5 py-2.5 text-sm font-semibold text-[#144726] hover:bg-[#B8923E] transition-colors" data-testid="footer-cta-consultation">
              Request Consultation <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/50 md:flex-row md:items-center">
          <p>&copy; {new Date().getFullYear()} {SITE.company}. All rights reserved.</p>
          <p>Crafted for landlords, developers, and corporate occupiers across India.</p>
        </div>
      </div>
    </footer>
  );
}
